// German for the three empty states and the degraded-zone shorthand.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Could not load': 'Konnte nicht geladen werden',
  'Nothing matches': 'Nichts passt',
  'Nothing here yet': 'Noch nichts vorhanden',
  'Nothing was written.': 'Es wurde nichts geschrieben.',
  'Try again': 'Erneut versuchen',
  'Clear the filter': 'Filter zurücksetzen',
  '{zone} could not be computed': '{zone} konnte nicht berechnet werden',
  'The {source} source answered: “{message}”': 'Die Quelle {source} antwortete: «{message}»',
}, 'EmptyState');
